// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { rootstock as _rootstock } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the rootstock chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 30
 * Chain Name: Rootstock Mainnet
 * Default Block Explorer: https://explorer.rsk.co
 * Default RPC URL: https://public-node.rsk.co
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { rootstock } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: rootstock,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const rootstock = createCommon({
	..._rootstock,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
